module.exports = __webpack_public_path__ + "img/views.ceedf3cd.svg";